import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { Branch } from '../../../shared/interfaces';
import { toast } from 'react-toastify';

const LOCAL_STORAGE_KEY = 'akropoli_subscribed_or_closed';

function SubscribeModal() {
  const [show, setShow] = useState(false);
  const [branches, setBranches] = useState<Branch[]>([]);
  const [email, setEmail] = useState('');
  const [selectedBranchId, setSelectedBranchId] = useState<number | null>(null);

  const handleClose = () => {
    setShow(false);
    localStorage.setItem(LOCAL_STORAGE_KEY, 'true');
  };

  const handleShow = () => setShow(true);

  useEffect(() => {
    const alreadyHandled = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (!alreadyHandled) {
      const timeout = setTimeout(() => {
        handleShow();
      }, 10000);
      return () => clearTimeout(timeout);
    }
  }, []);

  useEffect(() => {
    fetch('https://strapi-production-a706.up.railway.app/api/branches?sort=order:ASC')
      .then((res) => res.json())
      .then((data) => setBranches(data.data))
      .catch((err) => console.error('Failed to fetch branches:', err));
  }, []);

  const handleSubmit = async () => {
    if (!email || !selectedBranchId) {
      alert('Ju lutem plotësoni të gjitha fushat!');
      return;
    }

    try {
      const res = await fetch('https://strapi-production-a706.up.railway.app/api/subscriptions', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          data: {
            email,
            filiali: selectedBranchId,
          },
        }),
      });

      if (!res.ok) throw new Error('Request failed');

      toast.success('Faleminderit! Tani do të merrni njoftime për aktivitetet tona më të fundit.');
      localStorage.setItem(LOCAL_STORAGE_KEY, 'true');
      handleClose();
      setEmail('');
      setSelectedBranchId(null);
    } catch (error) {
      console.error('Failed to subscribe:', error);
      alert('Ndodhi një gabim gjatë dërgimit!');
    }
  };

  return (
    <Modal show={show} centered onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Subscribe për të ndëgjuar më shumë rreth aktiviteteve tona!</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row mb-3">
          <div className="col-md-10 mx-auto">
            <input
              type="text"
              className="form-control"
              placeholder="Shkruaj Email-in"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-10 mx-auto">
            <select
              className="form-control"
              value={selectedBranchId ?? ''}
              onChange={(e) => setSelectedBranchId(Number(e.target.value))}
            >
              <option value="">Zgjidh filialin</option>
              {branches?.map((branch) => (
                <option key={branch.id} value={branch.id}>
                  {branch?.city}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="text-center">
          <button className="button button--secondary" onClick={handleSubmit}>
            <span>Subscribe</span>
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default SubscribeModal;
